'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(
    'div',
    { className: 'ui-centered-wrapper' },
    _react2.default.createElement(_rpReactSvgIcon2.default, {
      iconName: 'spinner',
      size: '2XL',
      className: 'ui-animation_spinnerAnimation'
    })
  );
};

exports.default = Loading;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/components/Loading.js
// module id = 928
// module chunks = 0